import moment from "moment";
import React from "react";
import { Cell } from "react-table";
import { Ac2AccessGroupModel } from "src/api/access/ac-group-types";
import { BaseTooltip } from "src/components";
import DetailLink from "src/components/DetailLink";
import { PagePath } from "src/pages/product/details";
import { ViewYmdFormat } from "src/utils/common-util";
import { visitorSettings } from "../const";

export const accessGroupColumns = [
  {
    Header: "출입그룹 ID",
    accessor: "id",
    width: 120,
    sticky: "left",
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      const detailPath = `${PagePath.accessGroup.detail.replace(":id", value)}`;

      return (
        <DetailLink to={detailPath} className="text-underline">
          {value}
        </DetailLink>
      );
    },
  },
  {
    Header: "출입그룹명",
    accessor: "accessGroupName",
    width: 400,
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      return <BaseTooltip className="text-start w-100" contents={value || "-"} isSingleLine={true} />;
    },
  },
  {
    Header: "장치 수(대)",
    accessor: "deviceCount",
    width: 80,
    Cell: ({ row }: Cell<Ac2AccessGroupModel>) => {
      return <p className="w-100 text-right">{row.original.deviceIds?.length || "-"}</p>;
    },
  },
  {
    Header: "이용자 출입 가능 여부",
    accessor: "memberAccessYn",
    width: 160,
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      return <p className="w-100 text-center">{value ? "출입가능" : "출입불가"}</p>;
    },
  },
  {
    Header: "방문자 초대 가능 여부",
    accessor: "visitorAccessYn",
    width: 160,
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      return <p className="w-100 text-center">{value ? "초대가능" : "초대불가"}</p>;
    },
  },
  {
    Header: "앱 노출 여부",
    accessor: "visitorAccessGroupSelectableYn",
    width: 120,
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      return (
        <p className="w-100 text-center">
          {visitorSettings.find((item) => item.name === "visitorAccessGroupSelectableYn")?.options.find((option) => option.value === value)?.label ||
            "-"}
        </p>
      );
    },
  },
  {
    Header: "관리자 승인 방식",
    accessor: "visitorInvitationApprovalYn",
    width: 120,
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      return (
        <p className="w-100 text-center">
          {visitorSettings.find((item) => item.name === "visitorInvitationApprovalYn")?.options.find((option) => option.value === value)?.label ||
            "-"}
        </p>
      );
    },
  },
  {
    Header: "QR 발급 여부",
    accessor: "visitorAccessType",
    width: 120,
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      return (
        <p className="w-100 text-center">
          {visitorSettings.find((item) => item.name === "visitorAccessType")?.options.find((option) => option.value === value)?.label || "-"}
        </p>
      );
    },
  },
  {
    Header: "엘리베이터 연동",
    accessor: "floorAccessYn",
    width: 160,
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      return <p className="w-100 text-center">{value ? "ON" : "OFF"}</p>;
    },
  },
  {
    Header: "엘리베이터 이용 가능 층",
    accessor: "accessibleFloors",
    width: 160,
    Cell: ({ row }: Cell<Ac2AccessGroupModel>) => {
      const contents = row.original.accessibleFloors && row.original.accessibleFloors.length > 0 ? row.original.accessibleFloors.join(",") : "-";

      return <BaseTooltip className="text-center w-100" contents={contents} isSingleLine={true} />;
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "lastModifiedDate",
    width: 160,
    Cell: ({ value }: Cell<Ac2AccessGroupModel>) => {
      return <p className="w-100 text-center">{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</p>;
    },
  },
];

// CTRLROOM_ACCESS_GROUP_ACCESS_FLOORS feature 비활성 파트너에게는 숨겨야 하는 컬럼들의 accessor
export const floorAccessColumnAccessors = ["floorAccessYn", "accessibleFloors"];
